import React from 'react';
import { isPreviewPage } from '@bbkAdminUtils/is-preview-page';
import { useLocation } from '@bbkShared/react-router';
import { SuspenseLoader, type SuspenseLoaderProps } from './suspense-loader';

// Shell fallbacks also render before a hosted preview has mounted.
export const AdminRouteSuspenseLoader: React.FC<
  Pick<SuspenseLoaderProps, 'message'>
> = (props) => {
  const { pathname } = useLocation();
  const legacy = isPreviewPage(pathname);
  return (
    <SuspenseLoader {...props} presentation={legacy ? 'legacy' : 'sting'} />
  );
};
